"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceCategoryLibrary = void 0;
var content_1 = require("../content");
var UserServiceCategoryLibrary = /** @class */function () {
  function UserServiceCategoryLibrary() {}
  UserServiceCategoryLibrary.findAll = function () {
    return Object.values(this.items);
  };
  UserServiceCategoryLibrary.findByPk = function (id) {
    return this.items[id];
  };
  UserServiceCategoryLibrary.items = {
    1: {
      id: 1,
      code: 'individual',
      title_en: 'Individual classes',
      title_ru: 'Индивидуальные занятия',
      types: [content_1.MeetingTypeEnum.single, content_1.MeetingTypeEnum.group, content_1.MeetingTypeEnum.webinar, content_1.MeetingTypeEnum.stream]
    },
    2: {
      id: 2,
      code: 'speaking',
      title_en: 'Speaking practice',
      title_ru: 'Разговорная практика',
      types: [content_1.MeetingTypeEnum.talk]
    },
    3: {
      id: 3,
      code: 'exam_training',
      title_en: 'Exam training',
      title_ru: 'Подготовка к экзаменам и тестам',
      types: [content_1.MeetingTypeEnum.single, content_1.MeetingTypeEnum.group, content_1.MeetingTypeEnum.webinar, content_1.MeetingTypeEnum.stream]
    },
    4: {
      id: 4,
      code: 'for_children',
      title_en: 'For children',
      title_ru: 'Для детей',
      types: [content_1.MeetingTypeEnum.single, content_1.MeetingTypeEnum.group, content_1.MeetingTypeEnum.webinar, content_1.MeetingTypeEnum.stream]
    },
    5: {
      id: 5,
      code: 'discussion',
      title_en: 'Discussion',
      title_ru: 'Дискуссия',
      types: [content_1.MeetingTypeEnum.talk]
    },
    7: {
      id: 7,
      code: 'master_class',
      title_en: 'Master Class',
      title_ru: 'Мастер класс',
      types: [content_1.MeetingTypeEnum.talk]
    }
  };
  return UserServiceCategoryLibrary;
}();
exports.UserServiceCategoryLibrary = UserServiceCategoryLibrary;
